export enum SigningType {
  SWEEP_LARGE = "SWEEP_LARGE",
  SWEEP_AUGMENTER = "SWEEP_AUGMENTER",
  CPL = "CPL",
  BOX_LARGE = "BOX_LARGE",
  BOX_AUGMENTER = "BOX_AUGMENTER",
  SINGLE = "SINGLE",
}
